// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mp-top {
  background: #fff !important;
  height: 56px;
  min-height: 56px;
  flex-wrap: nowrap !important;
  gap: 10px !important;
  padding: 0 28px !important;
}
.mp-top .v2-topbar-actions {
  flex-wrap: nowrap;
  flex-shrink: 0;
}
.mp-top h1 {
  flex-shrink: 0;
}
@media (max-width: 1180px) {
  .mp-top .v2-topbar-hint {
    display: none;
  }
}
@media (max-width: 1000px) {
  .mp-current .v2-xs {
    display: none;
  }
}
.mp-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--v2-muted) !important;
  font-weight: 500;
  white-space: nowrap;
}
.mp-current {
  text-align: right;
  line-height: 1.25;
}
.mp-current-name {
  font-weight: 700;
  font-size: 13px;
  white-space: nowrap;
}
.mp-page {
  padding: 16px 28px 24px !important;
  gap: 16px !important;
}
.mp-presets {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.mp-presets-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--v2-text-2);
  margin-right: 2px;
}
.mp-preset {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  border-radius: 9px;
  font: inherit;
  font-size: 13px;
  color: var(--v2-primary);
  cursor: pointer;
  background: #fff;
  border: 1px solid var(--v2-border);
  white-space: nowrap;
}
.mp-preset.is-on {
  border: 2px solid var(--v2-primary);
  padding: 0 11px;
}
.mp-tag {
  font-size: 11px;
  font-weight: 700;
  color: var(--v2-muted);
  letter-spacing: 0.03em;
}
.mp-table-head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid var(--v2-border-soft);
}
.mp-tabs {
  display: inline-flex;
  padding: 3px;
  border-radius: 10px;
  background: var(--v2-hover);
  margin-right: 8px;
  flex-shrink: 0;
}
.mp-tabs a {
  height: 28px;
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--v2-text-2) !important;
  white-space: nowrap;
}
.mp-tabs a.is-on {
  background: #fff;
  font-weight: 600;
  color: var(--v2-primary) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.mp-chip {
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #d1d5db;
  background: #fff;
  color: var(--v2-primary);
  white-space: nowrap;
  flex-shrink: 0;
}
.mp-chip.is-on {
  border: 0;
  background: var(--v2-primary);
  color: #fff;
}
.mp-search {
  flex: 0 1 240px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0 10px;
  height: 34px;
  min-width: 170px;
  background: #fff;
}
.mp-search input {
  border: 0;
  outline: none;
  font: inherit;
  font-size: 13px;
  flex: 1;
  min-width: 0;
  background: transparent;
}
.mp-table {
  min-width: 860px;
}
.mp-table td,
.mp-table th:first-child,
.mp-table td:first-child {
  padding-top: 12px;
  padding-bottom: 12px;
}
.mp-table th:first-child,
.mp-table td:first-child {
  padding-left: 18px;
}
.mp-table tr.is-sel td {
  background: var(--v2-bg);
}
.mp-model {
  display: flex;
  align-items: center;
  gap: 12px;
}
.mp-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.mp-badge {
  font-size: 11px;
  padding: 1px 7px;
  border-radius: 999px;
  font-weight: 600;
  white-space: nowrap;
}
.mp-badge.is-default,
.mp-badge.is-vision {
  background: var(--v2-hover);
  color: var(--v2-text-2);
}
.mp-badge.is-ru {
  background: var(--v2-orange-bg);
  color: var(--v2-orange);
}
.mp-badge.is-bad {
  background: #fee2e2;
  color: var(--v2-red);
}
.mp-badge.is-rec {
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
}
.mp-bar {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mp-bar > div {
  flex: 1;
  height: 6px;
  border-radius: 999px;
  background: var(--v2-hover);
  overflow: hidden;
  min-width: 80px;
}
.mp-bar > div > div {
  height: 6px;
  border-radius: 999px;
  background: var(--v2-primary);
}
.mp-bar > span {
  font-weight: 600;
  width: 36px;
  text-align: right;
}
.mp-dim {
  color: var(--v2-text-2);
}
.mp-pick {
  height: 32px;
  padding: 0 14px;
  border-radius: 8px;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #d1d5db;
  background: #fff;
  color: var(--v2-primary);
  white-space: nowrap;
  flex: none;
}
.mp-pick.is-on {
  border: 0;
  background: var(--v2-primary);
  color: #fff;
}
.mp-foot {
  padding: 12px 18px;
  border-top: 1px solid var(--v2-border-soft);
  font-size: 12px;
  color: var(--v2-muted);
}
.mp-all {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-start;
}
.mp-filters {
  flex: 1 1 220px;
  max-width: 250px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.mp-fgroup {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mp-fcap {
  font-size: 12px;
  font-weight: 700;
  color: var(--v2-muted);
  letter-spacing: 0.03em;
}
.mp-check {
  text-align: left;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: 0;
  padding: 0;
  color: var(--v2-primary);
}
.mp-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  display: inline-block;
  background: #fff;
  border: 1px solid #9ca3af;
  flex: none;
}
.mp-box.is-on {
  background: var(--v2-primary);
  border-color: var(--v2-primary);
}
.mp-vendor {
  text-align: left;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 7px;
  padding: 6px 8px;
  color: var(--v2-primary);
  background: transparent;
}
.mp-vendor:hover {
  background: var(--v2-bg);
}
.mp-vendor.is-on {
  background: var(--v2-hover);
  font-weight: 600;
}
.mp-list {
  flex: 999 1 560px;
  min-width: 0;
  overflow: hidden;
}
.mp-list-head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  padding: 10px 16px;
  font-size: 13px;
  color: var(--v2-muted);
}
.mp-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: flex-start;
  padding: 12px 16px;
  border-top: 1px solid var(--v2-border-soft);
}
.mp-row.is-sel {
  background: var(--v2-bg);
}
.mp-price {
  text-align: right;
  flex: none;
  width: 190px;
}
.mp-price .v2-xs {
  white-space: nowrap;
}
.mp-more {
  padding: 12px 16px;
  border-top: 1px solid var(--v2-border-soft);
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/model-picker/models.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,aAAa;EACb,aAAa;EACb,eAAe;EACf,OAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".mp-top {\n  background: #fff !important;\n  height: 56px;\n  min-height: 56px;\n  flex-wrap: nowrap !important;\n  gap: 10px !important;\n  padding: 0 28px !important;\n}\n.mp-top .v2-topbar-actions {\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n}\n.mp-top h1 {\n  flex-shrink: 0;\n}\n@media (max-width: 1180px) {\n  .mp-top .v2-topbar-hint {\n    display: none;\n  }\n}\n@media (max-width: 1000px) {\n  .mp-current .v2-xs {\n    display: none;\n  }\n}\n.mp-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--v2-muted) !important;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.mp-current {\n  text-align: right;\n  line-height: 1.25;\n}\n.mp-current-name {\n  font-weight: 700;\n  font-size: 13px;\n  white-space: nowrap;\n}\n.mp-page {\n  padding: 16px 28px 24px !important;\n  gap: 16px !important;\n}\n.mp-presets {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n.mp-presets-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--v2-text-2);\n  margin-right: 2px;\n}\n.mp-preset {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 12px;\n  border-radius: 9px;\n  font: inherit;\n  font-size: 13px;\n  color: var(--v2-primary);\n  cursor: pointer;\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  white-space: nowrap;\n}\n.mp-preset.is-on {\n  border: 2px solid var(--v2-primary);\n  padding: 0 11px;\n}\n.mp-tag {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--v2-muted);\n  letter-spacing: 0.03em;\n}\n.mp-table-head {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.mp-tabs {\n  display: inline-flex;\n  padding: 3px;\n  border-radius: 10px;\n  background: var(--v2-hover);\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n.mp-tabs a {\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  padding: 0 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--v2-text-2) !important;\n  white-space: nowrap;\n}\n.mp-tabs a.is-on {\n  background: #fff;\n  font-weight: 600;\n  color: var(--v2-primary) !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n.mp-chip {\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 999px;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: var(--v2-primary);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.mp-chip.is-on {\n  border: 0;\n  background: var(--v2-primary);\n  color: #fff;\n}\n.mp-search {\n  flex: 0 1 240px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 0 10px;\n  height: 34px;\n  min-width: 170px;\n  background: #fff;\n}\n.mp-search input {\n  border: 0;\n  outline: none;\n  font: inherit;\n  font-size: 13px;\n  flex: 1;\n  min-width: 0;\n  background: transparent;\n}\n.mp-table {\n  min-width: 860px;\n}\n.mp-table td,\n.mp-table th:first-child,\n.mp-table td:first-child {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.mp-table th:first-child,\n.mp-table td:first-child {\n  padding-left: 18px;\n}\n.mp-table tr.is-sel td {\n  background: var(--v2-bg);\n}\n.mp-model {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.mp-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n.mp-badge {\n  font-size: 11px;\n  padding: 1px 7px;\n  border-radius: 999px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.mp-badge.is-default,\n.mp-badge.is-vision {\n  background: var(--v2-hover);\n  color: var(--v2-text-2);\n}\n.mp-badge.is-ru {\n  background: var(--v2-orange-bg);\n  color: var(--v2-orange);\n}\n.mp-badge.is-bad {\n  background: #fee2e2;\n  color: var(--v2-red);\n}\n.mp-badge.is-rec {\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n}\n.mp-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.mp-bar > div {\n  flex: 1;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--v2-hover);\n  overflow: hidden;\n  min-width: 80px;\n}\n.mp-bar > div > div {\n  height: 6px;\n  border-radius: 999px;\n  background: var(--v2-primary);\n}\n.mp-bar > span {\n  font-weight: 600;\n  width: 36px;\n  text-align: right;\n}\n.mp-dim {\n  color: var(--v2-text-2);\n}\n.mp-pick {\n  height: 32px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: var(--v2-primary);\n  white-space: nowrap;\n  flex: none;\n}\n.mp-pick.is-on {\n  border: 0;\n  background: var(--v2-primary);\n  color: #fff;\n}\n.mp-foot {\n  padding: 12px 18px;\n  border-top: 1px solid var(--v2-border-soft);\n  font-size: 12px;\n  color: var(--v2-muted);\n}\n.mp-all {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-items: flex-start;\n}\n.mp-filters {\n  flex: 1 1 220px;\n  max-width: 250px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.mp-fgroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.mp-fcap {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--v2-muted);\n  letter-spacing: 0.03em;\n}\n.mp-check {\n  text-align: left;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: none;\n  border: 0;\n  padding: 0;\n  color: var(--v2-primary);\n}\n.mp-box {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  display: inline-block;\n  background: #fff;\n  border: 1px solid #9ca3af;\n  flex: none;\n}\n.mp-box.is-on {\n  background: var(--v2-primary);\n  border-color: var(--v2-primary);\n}\n.mp-vendor {\n  text-align: left;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 7px;\n  padding: 6px 8px;\n  color: var(--v2-primary);\n  background: transparent;\n}\n.mp-vendor:hover {\n  background: var(--v2-bg);\n}\n.mp-vendor.is-on {\n  background: var(--v2-hover);\n  font-weight: 600;\n}\n.mp-list {\n  flex: 999 1 560px;\n  min-width: 0;\n  overflow: hidden;\n}\n.mp-list-head {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  padding: 10px 16px;\n  font-size: 13px;\n  color: var(--v2-muted);\n}\n.mp-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  align-items: flex-start;\n  padding: 12px 16px;\n  border-top: 1px solid var(--v2-border-soft);\n}\n.mp-row.is-sel {\n  background: var(--v2-bg);\n}\n.mp-price {\n  text-align: right;\n  flex: none;\n  width: 190px;\n}\n.mp-price .v2-xs {\n  white-space: nowrap;\n}\n.mp-more {\n  padding: 12px 16px;\n  border-top: 1px solid var(--v2-border-soft);\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
